
import Activity from "../../../assets/duotone/Activity.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ActivityIcon({ className, dataTestid = "ActivityIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Activity data-testid={dataTestid} className={classes} {...rest} />
  );
}
